export class AircraftModelModel {
    public aircraftModelId = 0;
    public aircraftMakeId = 0;
    public aircraftModelDisplayValue: string;
    public aircraftMakeDisplayValue: string;
}
